import React from 'react';
import { CheckIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
import { checkoutUrl, price, priceBefore, productName, totalBonuses, totalVolumes } from '../data/offer';
const assurances = ['7-day guarantee', 'Secure payment', 'Instant access', 'Teach with confidence starting today'];
export function FinalCta() {
  return <section className="bg-stage-deep energy-glow py-16 sm:py-20" aria-labelledby="final-title" data-id="element-70" data-mp="1jclmshcm7vul">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-71" data-mp="1eek2jt3gdqhj">
        <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.16em] text-greenGlow" data-id="element-72" data-mp="1ebxrhjhcssuk">
          <ZapIcon className="h-4 w-4" aria-hidden="true" data-id="element-73" data-mp="1o43l0xn97ibv" /> {productName}
        </p>
        <h2 id="final-title" className="mx-auto mt-5 max-w-2xl text-balance text-3xl font-extrabold text-white sm:text-4xl" data-id="element-74" data-mp="1o67oxfl5khc5">
          Created by specialists, for educators worldwide
        </h2>

        <Countdown light className="mt-8" data-id="element-75" data-mp="1x2p18m596l9h" />

        <div className="mt-8 flex flex-col gap-5 rounded-xl bg-white p-6 text-left shadow-lift sm:flex-row sm:items-center sm:justify-between" data-id="element-76" data-mp="n6nu779cel10">
          <p data-id="element-77" data-mp="s6s2ia03k9g5">
            <b className="block text-sm uppercase leading-tight text-ink" data-id="element-78" data-mp="x3s5ud5kay3k">{productName}</b>
            <span className="text-sm text-muted" data-id="element-79" data-mp="x64wrftasisr">
              {totalVolumes} volumes + {totalBonuses} bonuses · Instant access
            </span>
          </p>
          <div className="sm:text-right" data-id="element-80" data-mp="163p1wzua6z8n">
            <p className="text-sm text-muted" data-id="element-81" data-mp="1b3js1168fksn">
              <span className="mr-2 line-through" data-id="element-82" data-mp="1b2i6g2rlbfwo">{priceBefore}</span>
              <b className="text-base text-ink" data-id="element-83" data-mp="1ftqdis5g6p6o">{price}</b>
            </p>
            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" size="sm" className="mt-2" data-id="element-84" data-mp="1fwmd0kwy1lx8">
              Get my collection now
            </Button>
          </div>
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-mutedDark" data-id="element-85" data-mp="1pqmod4itjnee">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-86" data-mp="3qvqidrtugwkb">
              <CheckIcon className="h-4 w-4 text-greenGlow" aria-hidden="true" data-id="element-87" data-mp="3lvubnktrir12" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}